import React, { useState, useRef, useEffect } from "react";
import axios from "axios"; // 引入 Axios 库
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

// Cloudflare Pages 构建时通过 REACT_APP_API_URL 注入公开的 HTTPS 后端地址。
// 本地开发仍默认连接到本机的 OpenAI 兼容服务。
const DOMAIN = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(
  /\/$/,
  ""
);
const API_URL = `${DOMAIN}/v1/chat/completions`; // 导入后端api接口
const MODEL = process.env.REACT_APP_MODEL || "secgpt-7b";

const initialMessages = [
  { sender: "model", text: `您好！SecGPT-Pro 已连接到后端服务 (${DOMAIN})。` },
];

const ChatComponent = () => {
  const [messages, setMessages] = useState(initialMessages);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [messages]);

  const handlevoice = () => {
    if (listening) {
      // 如果正在听，则停止
      setInputText(inputText + transcript);
      SpeechRecognition.stopListening();
    } else {
      // 如果没有在听，则开始
      // 保持 continuous: true 允许用户连续说话，直到手动点击停止
      resetTranscript();
      SpeechRecognition.startListening({ continuous: true, language: "zh-CN" });
    }
  };
  if (!browserSupportsSpeechRecognition) {
    return (
      <span>抱歉，您的浏览器不支持 Web Speech API，无法使用语音输入功能。</span>
    );
  }

  const handleSendMessage = async () => {
    if (!inputText.trim() || loading) return;

    const userMessage = { sender: "user", text: inputText };

    // 1. 更新聊天记录，显示用户消息
    setMessages((prev) => [...prev, userMessage]);

    // 2. 清空输入并设置加载状态
    const currentInput = inputText;
    setInputText("");
    setLoading(true);

    try {
      const requestPayload = {
        model: MODEL,
        messages: [
          {
            content: currentInput, // 用户输入作为 content
            role: "user", // 假设用户输入的 role 为 "user"
            name: "permeate", // 您可以自定义或从状态中获取用户名
          },
        ],
      };
      // **使用 Axios 进行 POST 请求**
      const response = await axios.post(
        API_URL,
        requestPayload // 传递构造好的 JSON 对象
      );

      // Axios 自动处理 JSON 解析，响应数据在 response.data 中
      const data = response.data;

      const modelResponse = {
        sender: "model",
        text: data.choices[0].message.content || "模型未能返回有效回复。",
      };

      // 4. 更新聊天记录，显示模型回复
      setMessages((prev) => [...prev, modelResponse]);
    } catch (error) {
      console.error("API 调用失败:", error.message, error.response);

      let errorMessageText = `连接到 ${API_URL} 失败。`;
      if (error.response) {
        // Axios 错误，表示服务器已响应，但状态码非 2xx
        errorMessageText += `状态码: ${error.response.status}。请检查后端 CORS 配置。`;
      } else if (error.request) {
        // Axios 错误，请求已发出但没有收到响应（可能是网络或 CORS 错误）
        errorMessageText += `未收到服务器响应。`;
      }

      const errorMessage = { sender: "model", text: errorMessageText };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "12px auto 0",
        border: "1px solid #ccc",
        height: "95vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "rgba(255, 255, 255, 0.3)",
      }}
    >
      <div
        style={{
          flexGrow: 1,
          padding: "10px",
          overflowY: "auto",
          backgroundColor: "rgba(255, 255, 255, 0.3)",
        }}
      >
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              marginBottom: "10px",
              padding: "8px",
              borderRadius: "10px",
              maxWidth: "85%",
              backgroundColor: msg.sender === "user" ? "#d0eaff" : "#fff",
              marginLeft: msg.sender === "user" ? "auto" : "0",
              marginRight: msg.sender === "model" ? "auto" : "0",
              textAlign: msg.sender === "user" ? "right" : "left",
              border: msg.sender === "model" ? "1px solid #eee" : "none",
            }}
          >
            <strong style={{ fontSize: "0.9em", color: "#555" }}>
              {msg.sender === "user" ? "你" : "模型"}
            </strong>
            <p style={{ margin: "3px 0 0 0" }}>{msg.text}</p>
          </div>
        ))}

        {loading && (
          <div style={{ fontStyle: "italic", color: "#888", padding: "8px" }}>
            模型正在处理...
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      {/* 消息输入区域 */}
      <div
        style={{
          padding: "10px",
          borderTop: "1px solid #ccc",
          display: "flex",
        }}
      >
        <textarea
          style={{
            flexGrow: 1,
            padding: "8px",
            marginRight: "10px",
            resize: "none",
          }}
          rows="3"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="请输入您的问题..."
          disabled={loading}
        />
        <button
          onClick={handleSendMessage}
          disabled={loading || !inputText.trim()}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff65",
            color: "white",
            border: "2px solid #000000ff",
            borderRight: "1px solid #000000ff",

            cursor: "pointer",
          }}
        >
          发送
        </button>
        <button
          onClick={handlevoice}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "2px solid #000000ff",
            borderLeft: "1px solid #000000ff",

            cursor: "pointer",
          }}
        >
          {listening ? "🔴 点击停止录音" : "🎙️ 点击开始语音输入"}
        </button>
      </div>
    </div>
  );
};

export default ChatComponent;
